<ng-container *ngIf="payload?.url$ | async as iframeUrl else loading">
  <iframe [src]="iframeUrl | safe: 'resourceUrl'" class="iframe-widget width-100 height-100"></iframe>
</ng-container>

<ng-template #loading>
  <gen-overlay-loader></gen-overlay-loader>
</ng-template>

